import React from 'react';
import { StyleSheet } from 'react-native';
import { Button } from '@rneui/themed';
import { FAIcon, useReaderBackgroundColor, useReaderColors, } from '@annunciate/ui';
export const ReaderButton = ({ name, onPress, }) => {
    const bkgColor = useReaderBackgroundColor();
    const { backgroundInverted: iconColor } = useReaderColors();
    return (React.createElement(Button, { icon: React.createElement(FAIcon, { name: name, size: 40, color: iconColor }), onPress: onPress, containerStyle: [{ width: '10%' }, styles.height], style: styles.height, buttonStyle: [styles.height, {
                backgroundColor: bkgColor,
            }] }));
};
const styles = StyleSheet.create({
    height: {
        height: '100%',
    },
});
//# sourceMappingURL=ReaderButton.js.map